/** 将配置接口字段错误转为可显示文字，网络失败保留独立提示。 */
export function productionError(error) {
  const data = error.response && error.response.data;
  if (!data) return error.message || '请求失败，请重试';
  return Object.keys(data).filter(key => key !== 'code' || Array.isArray(data[key])).map(key => {
    const value = data[key];
    return Array.isArray(value) ? value.join('；') : typeof value === 'object' ? JSON.stringify(value) : String(value);
  }).join('；') || '请求失败，请重试';
}

export function validateCategoryName(value, original) {
  if (original !== undefined && value === original) return true;
  return value.split(/[,，]/).every(name => {
    name = name.trim();
    return name.length <= 32 && /^(manual|auto)_[a-z0-9_]+$/.test(name);
  });
}

/** 时间仅作展示裁剪，保留接口时区对应的时刻；前两参用于兼容表格formatter签名。 */
export function formatProductionDateTime(row, column, value) {
  const match = typeof value === 'string' && value.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2}:\d{2})/);
  return match ? `${match[1]} ${match[2]}` : '-';
}
